import { UntypedFormArray } from '@angular/forms';
import { Translation } from '@app/translate/models/translation';
import { TranslationFormModel } from '@app/translate/models/translation-form-model';
import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { FormMappingAttribute } from '@app/utils/form-mapping/decorators/form-mapping-attribute';
import { Local, StringInput } from '@app/utils/form-mapping/helpers/default-attributes';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';

type KeyValue = {
  key: string;
  value: string;
};

@FormMapping()
export class TranslationEditFormModel extends FormMappingModel {
  @StringInput
  key: string;

  @Local({
    initialValue: 'default',
  })
  mode: 'default' | 'specific';

  @FormMappingAttribute({
    isArray: true,
    mergeFunction: (o, value: KeyValue[], attr) => {
      const translations = {};

      Object.values(value).forEach((value) => {
        translations[value.key] = value.value;
      });

      o[attr] = translations;
    },
    parseFunction: (value, o: Translation) => {
      const translations = Object.entries(o.overrides);

      return translations.map(([key, value]) =>
        TranslationFormModel.from({
          key,
          value,
        })
      );
    },
  })
  overrides: UntypedFormArray;

  @FormMappingAttribute({
    isArray: true,
    mergeFunction: (o, value: KeyValue[], attr) => {
      const translations = {};

      Object.values(value).forEach((value) => {
        translations[value.key] = value.value;
      });

      o[attr] = translations;
    },
    parseFunction: (value, o: Translation) => {
      const translations = Object.entries(o.translations);

      return translations.map(([key, value]) =>
        TranslationFormModel.from({
          key,
          value,
        })
      );
    },
  })
  translations: UntypedFormArray;
}
